// fr_pms_reservations.ts
// Tłumaczenia dla PMS.Reservations.tsx i PMS.Reservations.Table.tsx

export const frPmsReservations = {

  summary: {
    total: "<strong>{{count}}</strong> au total",
    checkedIn_one: "<strong>{{count}}</strong> client enregistré",
    checkedIn_other: "<strong>{{count}}</strong> clients enregistrés",
    arrivingToday_one: "<strong>{{progress}}</strong> arrivée aujourd’hui",
    arrivingToday_other: "<strong>{{progress}}</strong> arrivées aujourd’hui",
  },
  wizard: {
    review: {
      documentChecked: "Document vérifié",
      vipLevel: "Niveau VIP",
      marketing: "Consentement marketing",
      agreed: "Accepté",
      declined: "Refusé",
      extras: "Suppléments",
      cityTax: "Taxe de séjour",
      deposit: "Acompte",
      blockPackages: "Forfaits du bloc",
    },
    selectedRooms_one: "Sélection : {{count}} chambre.",
    selectedRooms_other: "Sélection : {{count}} chambres.",
    suitableRooms_one: "Afficher uniquement les chambres adaptées à {{count}} client",
    suitableRooms_other: "Afficher uniquement les chambres adaptées à {{count}} clients",
    groupRoomsSummary: "Groupe · {{rooms}} : {{numbers}}",
    groupOccupancyHint: "Xentros répartit automatiquement les clients entre les chambres. La répartition peut être ajustée, mais les totaux doivent rester identiques : adultes : {{adults}}, enfants : {{children}}.",
  },

  title:     "Reservations",
  search:    "Rechercher un client ou un ID...",

  // ── Akcje ─────────────────────────────────────────────────────────────────
  actions: {
    newReservation:     "Nouvelle reservation",
    modifyReservation:  "Modifier la reservation",
    modify:             "Modifier",
    cancelReservation:  "Annuler la reservation",
    confirmCancellation:"Confirmer l'annulation",
    save:               "Enregistrer",
    saving:             "Enregistrement...",
    cancelling:         "Annulation...",
  },

  // ── Filtry statusów ───────────────────────────────────────────────────────
  status: {
    all:        "Toutes",
    confirmed:  "Confirmee",
    inHouse:    "En sejour",
    checkedOut: "Depart effectue",
    cancelled:  "Annulee",
    noShow:     "No-show",
    pending:    "En attente",
    waitlist:   "Liste d'attente",
    planned:    "Planifiee",
    completed:  "Terminee",
    booked:     "Reservee",
    active:     "Active",
    blocked:    "Bloquee",
    departing:  "Depart aujourd'hui",
    authorized: "Autorisee",
    captured:   "Capturee",
    inProgress: "En cours",
  },

  // ── Typy rezerwacji ───────────────────────────────────────────────────────
  type: {
    individual: "Individuelle",
    group:      "Groupe",
    shared:     "Partagee",
    direct:     "Directe",
  },

  // ── Pola formularza ───────────────────────────────────────────────────────
  fields: {
    guest:      "Client",
    room:       "Chambre",
    checkIn:    "Arrivee",
    checkOut:   "Depart",
    nights:     "Nuits",
    adults:     "Adultes",
    children:   "Enfants",
    rate:       "Tarif",
    total:      "Total",
    deposit:    "Depot",
    balance:    "Solde",
    notes:      "Notes",
  },

  // ── Sekcja historii ───────────────────────────────────────────────────────
  history: {
    title:      "Historique des reservations",
    auditTrail: "Journal d'audit pour cette reservation.",
    captured:   "Capture depuis la gestion des reservations.",
  },

  // ── Grupy rezerwacji ──────────────────────────────────────────────────────
  groups: {
    title:           "Groupes et evenements",
    summary:         "Resume du groupe",
    create:          "Creer un groupe",
    edit:            "Modifier le groupe",
    save:            "Enregistrer le groupe",
    newReservation:  "Nouvelle reservation de groupe",
    editReservation: "Modifier la reservation de groupe",
    groupedRooms:    "Chambres de groupe",
    linkedEvents:    "Evenements lies",
    primaryEvent:    "Evenement principal",
    setPrimary:      "Definir comme principal",
    masterDetails:   "Details principaux et contact primaire.",
    optionalEvents:  "Evenements optionnels lies a la reservation de groupe.",
    editInline:      "Modifiez les details de la reservation sur place sans quitter l'espace de travail.",
    createTrack:     "Creez et suivez les reservations groupees et les evenements lies dans une seule vue.",
    saved:           "Reservation de groupe enregistree",
    updated:         "Reservation de groupe mise a jour",
  },

  // ── Overbooking ───────────────────────────────────────────────────────────
  overbooking: "Controle du surbooking",

  // ── Lista oczekujących ────────────────────────────────────────────────────
  waitlistMissingGuest: "L'entree de la liste d'attente ne contient pas de profil client.",

  // ── Typy wydarzeń ─────────────────────────────────────────────────────────
  eventTypes: {
    meeting:       "Reunion",
    conference:    "Conference",
    banquet:       "Banquet",
    wedding:       "Mariage",
    corporateEvent:"Evenement d'entreprise",
    other:         "Autres",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    saved:                "Reservation mise a jour",
    cancelled:            "Reservation annulee",
    correctionRequired:   "Veuillez corriger les erreurs de reservation signalees.",
    groupCorrectionRequired:"Veuillez corriger les erreurs de reservation de groupe signalees.",
    noEmail:              "Aucune adresse e-mail du destinataire pour cette reservation.",
    confirmationSent:     "E-mail de confirmation envoye.",
    depositCaptured:      "Depot enregistre.",
  },

} as const;

export default frPmsReservations;
